// extracted by mini-css-extract-plugin
export default {"wrap":"gH-z","fullWidth":"hH-z","hideOnDesktop":"iH-z","content":"jH-z","hasOpenedNav":"kH-z","crumbsList":"lH-z","dropdownsWrap":"mH-z"};